export default __webpack_public_path__ + "05aac87a9e44ef2871c443455c375f21.svg";